import { parseNumericValue } from './resumoDgAnalysis'

const getDateValue = (value) => {
  if (!value) return 0
  const date = value instanceof Date ? value : new Date(value)
  const time = date.getTime()
  return Number.isFinite(time) ? time : 0
}

export const getRowAge = (row) =>
  parseNumericValue(row?.idadeMatriz ?? row?.idadeNovPri) ??
  Number.POSITIVE_INFINITY

export const sortResumoDgRows = (rows = []) =>
  [...rows].sort(
    (left, right) =>
      getRowAge(left) - getRowAge(right) ||
      getDateValue(left?.dataDg) - getDateValue(right?.dataDg) ||
      String(left?.codVaca ?? '').localeCompare(
        String(right?.codVaca ?? ''),
        'pt-BR',
        {
          numeric: true,
        },
      ),
  )

export const getIatfReference = (batch) =>
  batch?.dataIatf || batch?.dataIatfAt || batch?._raw?.dataIatf_at || null
